module.exports = __webpack_public_path__ + "img/6.9bd58584.jpg";